import React, { useEffect } from 'react';
import streamSaver, { createWriteStream } from 'streamsaver';
declare const MediaRecorder: any;

streamSaver.mitm =
    'https://seastate-sw-proxy.wemakewaves.digital/mitm.html?v=1';

interface IRecordProps {
    screenRecordingStream: MediaStream | null;
    userMediaStream: MediaStream | null;
    sessionName: string;
}

function Record({
    screenRecordingStream,
    userMediaStream,
    sessionName
}: IRecordProps) {
    useEffect(() => {
        if (userMediaStream && userMediaStream.getAudioTracks().length) {
            screenRecordingStream!.addTrack(
                userMediaStream.getAudioTracks()[0]
            );
        }

        let mediaRecorder = new MediaRecorder(screenRecordingStream);
        mediaRecorder.start();

        /* Much of the implementation below is taken from the streamsaver documentation and isn't well tested */
        const fileStream = createWriteStream(
            `${sessionName || 'My Seastate recording'}.webm`
        );
        const writer = fileStream.getWriter();

        let chunks: Promise<void | {}> = Promise.resolve();
        const fr = new FileReader();
        mediaRecorder.ondataavailable = ({ data }: any) => {
            chunks = chunks.then(
                () =>
                    new Promise(resolve => {
                        fr.onload = () => {
                            writer.write(
                                new Uint8Array(fr.result as ArrayBuffer)
                            );
                            resolve();
                        };
                        fr.readAsArrayBuffer(data);
                    })
            );
        };

        // return a function to stop the recording
        return function stopRecording() {
            mediaRecorder.stop();
            setTimeout(
                () =>
                    chunks.then(evt => {
                        console.log('closing writer');
                        writer.close();
                    }),
                1000
            );
        };
    }, [screenRecordingStream, sessionName]);

    return <div data-testid="recorder" />;
}

export default Record;
